import { render, staticRenderFns } from "./TheCarousel.vue?vue&type=template&id=4fb3875d&scoped=true&"
import script from "./TheCarousel.vue?vue&type=script&lang=ts&"
export * from "./TheCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./TheCarousel.vue?vue&type=style&index=0&id=4fb3875d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3875d",
  null
  
)

export default component.exports